import './SettingsHome.scss'

import React from 'react'
import { Image } from 'react-bootstrap'
import { push } from 'react-router-redux'
import UpdateAppModal from 'common/views/components/UpdateAppModal'
import cx from 'bem-classnames'

import {
  PRICE, BUYER_TYPE, DO_NOT_DISTURB, PROPERTY_TYPE
} from 'common/constants'

import { labelFor, sortOptionsMap } from 'common/util/helper'
import { isEmbedded } from 'common/util/features'
import {download_agent_agreement, download_w9} from '../../../redux/settings'

const zipsToLabel = (zipObjs) => {
  let zips = []
  zipObjs.map((zip) => {
    zips.push(zip.zipcode)
  })
  return zips.join(', ')
}

const OptionsSection = ({ dispatch, auth }) => {

  const agentAgreement = () => {
    dispatch(download_agent_agreement()).then(response => {
      window.open(response.pdf_url, '_blank')
    })
  }

  const w9 = () => {
    dispatch(download_w9()).then(response => {
      window.open(response.pdf_url, '_blank')
    })
  }

  return (
    <div>
      <div className="SettingsHome__support--title">Opcity Support</div>
      <div className="SettingsHome__section">
        <div className="SettingsHome__item clickable">
        <a href="https://support.realtor.com/s/" className="SettingsHome__link">
        <i className="SettingsHome__icon fa fa-question-circle-o"/>
        <i className="SettingsHome__indicator fa fa-chevron-right compensate" aria-hidden="true"/>
        <div className="SettingsHome__item-inner">
        <div className="SettingsHome__label">AGENT HELP CENTER</div>
      </div>
      </a>
      </div>
      <div className="SettingsHome__item clickable" onClick={() => dispatch(push({ pathname: '/settings/terms' }))}>
      <i className="SettingsHome__icon fa fa-file-text-o"/>
        <i className="SettingsHome__indicator fa fa-chevron-right compensate" aria-hidden="true"/>
        <div className="SettingsHome__item-inner">
        <div className="SettingsHome__label">TERMS & CONDITIONS</div>
      </div>
      </div>
      { auth.user.signed_agreement && <div className="SettingsHome__item clickable" onClick={agentAgreement}>
        <i className="SettingsHome__icon fa fa-file-pdf-o"/>
        <i className="SettingsHome__indicator fa fa-download SettingsHome--compensate" aria-hidden="true"/>
        <div className="SettingsHome__item-inner">
          <div className="SettingsHome__label">DOWNLOAD AGENT REFERRAL AGREEMENT</div>
        </div>
      </div> }
      <div className="SettingsHome__item clickable" onClick={w9}>
        <i className="SettingsHome__icon fa fa-file-o SettingsHome--w9"/>
        <i className="SettingsHome__indicator fa fa-download SettingsHome--compensate" aria-hidden="true"/>
        <div className="SettingsHome__item-inner">
          <div className="SettingsHome__label">DOWNLOAD OPCITY FORM W-9</div>
        </div>
      </div>
    </div>
  </div>
  )
}

const SettingsHome = ({ dispatch, settings, auth }) => {
  const blockedZips = (settings.zip_blocks.length > 0) ?
    settings.zip_blocks.length >= 8 ?
      <div>Disabled: {settings.zip_blocks.length} Zip Codes</div>
      : <div>Disabled: {zipsToLabel(settings.zip_blocks)}</div>
    : <div>Accept All</div>
  const priceCategories = Object.keys(settings.price_categories).length == PRICE.length ? <div>Accept All</div> : <div>Disabled: {sortOptionsMap(PRICE, PRICE.map(item => item.value).filter((key) => !settings.price_categories[key]).map((key) => labelFor(PRICE, key))).join(', ')}</div>
  const clientCategories = Object.keys(settings.client_categories).length == BUYER_TYPE.length ? <div>Accept All</div> : <div>Disabled: {sortOptionsMap(BUYER_TYPE, BUYER_TYPE.map(item => item.value).filter((key) => !settings.client_categories[key]).map((key) => labelFor(BUYER_TYPE, key))).join(', ')}</div>
  const propertyTypeCategories = Object.keys(settings.property_categories).length == PROPERTY_TYPE.length ? <div>Accept All</div> : <div>Disabled: {sortOptionsMap(PROPERTY_TYPE, PROPERTY_TYPE.map(item => item.value).filter((key) => !settings.property_categories[key]).map((key) => labelFor(PROPERTY_TYPE, key))).join(', ')}</div>

  const snoozeValue = !settings.existing_snooze ?
    <div><i className="fa fa-check"/> Notifications Enabled</div> :
    <div className="SettingsHome__value--warning">Zzzz. Will resume in: <span className="SettingsHome__value--danger">{settings.existing_snooze}</span></div>

  const doNotDisturbValue = settings.do_not_disturb_enabled ?
    <div><i className="fa fa-clock-o SettingsHome__value--warning"/> No alerts from {labelFor(DO_NOT_DISTURB, settings.do_not_disturb_start)} to {labelFor(DO_NOT_DISTURB, settings.do_not_disturb_end)}</div> :
    <div><i className="fa fa-check"/> Receive lead alerts any time</div>

  const mileText = (parseFloat(settings.agent_distance_category) === 1) ? 'mile' : 'miles'
  const bigLocation = settings.base_zip && settings.licenses.length > 1
  const locationValue = settings.base_zip ?
    <div>
      <div>Within {settings.agent_distance_category} {mileText} of: <span className="SettingsHome__value--info">{settings.base_zip}</span></div>
      {settings.licenses.length > 1 ? <div>Licensed: {settings.licenses.map(l => l.state).join(", ")}</div> : null}
    </div> :
    <div>No Location Filter Configured</div>

  const notificationModeValue = settings.notification_mode == 'mobile' ? 'Mobile Push Notification' : 'SMS / Text Message'

  const isEmerging = auth.user.agent_experience_level === 'emerging'
  const disableClasses = {
    name: 'SettingsHome__item',
    modifiers: ['disabled']
  }

  let accountSubtitle = <div className="SettingsHome__header__title">My Account</div>
  if (auth.user.agent_experience_level === 'emerging') {
    accountSubtitle = <div className="SettingsHome__header__agent-level__emerging">Emerging Agent</div>
  } else {
    accountSubtitle = <div className="SettingsHome__header__agent-level__experienced">Experienced Agent</div>
  }

  const goToAvatar = () => {
    dispatch(push({ pathname: '/settings/avatar' }))
  }

  return (
    <div className="SettingsHome">
      <div className="SettingsHome__header">
        <div className="SettingsHome__header__avatar" onClick={goToAvatar}>
          {
            settings.image_path ?
              <Image src={settings.image_path} className="SettingsHome__header__user-image" />
              : <div>
              <div className="SettingsHome__header__img-account"></div>
              <i className="fa fa-plus-circle" />
            </div>
          }
        </div>
        <div className="SettingsHome__header__name">{settings.name}</div>
        {accountSubtitle}
      </div>
      { !settings.mobile_enabled &&
        <a href="https://mobile.opcity.com" target="_blank" rel="noopener noreferrer">
          <div className="SettingsHome__mobile-notification">
            <div className="SettingsHome__mobile-notification__img"><div></div></div>
            <div className="SettingsHome__mobile-notification__text-wrapper">
              <div>Want lead alerts faster?</div>
              <p>Download the Opcity Mobile app</p>
            </div>
            <i className="SettingsHome__indicator fa fa-chevron-right" aria-hidden="true"/>
          </div>
        </a>}
      <div className="SettingsHome__section">
        <div className="SettingsHome__item clickable" onClick={() => dispatch(push({ pathname: '/settings/location' }))}>
          <i className="SettingsHome__icon SettingsHome__icon--location"/>
          <i className={(bigLocation ? "SettingsHome__indicator-low" : "SettingsHome__indicator") + " fa fa-chevron-right"} aria-hidden="true"/>
          <div className="SettingsHome__item-inner">
            <div className="SettingsHome__label">Location</div>
            <div className="SettingsHome__value">{locationValue}</div>
          </div>
        </div>
        <div className={`${cx(disableClasses, {disabled: isEmerging})} clickable`} onClick={() => dispatch(push({ pathname: '/settings/blocked-zipcodes' }))}>
          <i className="SettingsHome__icon SettingsHome__icon--blocked"/>
          <i className="SettingsHome__indicator fa fa-chevron-right" aria-hidden="true"/>
          <div className="SettingsHome__item-inner">
            <div className="SettingsHome__label">Disabled Zip Codes</div>
            <div className="SettingsHome__value">{blockedZips}</div>
            { isEmerging && <div className="SettingsHome__lock" /> }
          </div>
        </div>
        <div className="SettingsHome__item clickable" onClick={() => dispatch(push({ pathname: '/settings/client' }))}>
          <i className="SettingsHome__icon SettingsHome__icon--handshake"/>
          <i className="SettingsHome__indicator fa fa-chevron-right" aria-hidden="true"/>
          <div className="SettingsHome__item-inner">
            <div className="SettingsHome__label">Client Types</div>
            <div className="SettingsHome__value">{clientCategories}</div>
          </div>
        </div>
        <div className={`${cx(disableClasses, {disabled: isEmerging})} clickable`} onClick={() => dispatch(push({ pathname: '/settings/price' }))}>
          <i className="SettingsHome__icon SettingsHome__icon--dollar"/>
          <i className="SettingsHome__indicator fa fa-chevron-right" aria-hidden="true"/>
          <div className="SettingsHome__item-inner">
            <div className="SettingsHome__label">Price Ranges</div>
            <div className="SettingsHome__value">{priceCategories}</div>
            { isEmerging && <div className="SettingsHome__lock" /> }
          </div>
        </div>
        <div className="SettingsHome__item clickable" onClick={() => dispatch(push({ pathname: '/settings/property' }))}>
          <i className="SettingsHome__icon SettingsHome__icon--property"/>
          <i className="SettingsHome__indicator fa fa-chevron-right" aria-hidden="true"/>
          <div className="SettingsHome__item-inner">
            <div className="SettingsHome__label">Property Types</div>
            <div className="SettingsHome__value">{propertyTypeCategories}</div>
          </div>
        </div>
      </div>

      <div className="SettingsHome__support--title">Notifications</div>
      <div className="SettingsHome__section">
        <div className="SettingsHome__item clickable" onClick={() => dispatch(push({ pathname: '/settings/snooze' }))}>
          <i className="SettingsHome__icon SettingsHome__icon--snooze"/>
          <i className="SettingsHome__indicator fa fa-chevron-right" aria-hidden="true"/>
          <div className="SettingsHome__item-inner">
            <div className="SettingsHome__label">Snooze Lead Alerts</div>
            <div className="SettingsHome__value">{snoozeValue}</div>
          </div>
        </div>
        <div className="SettingsHome__item clickable" onClick={() => dispatch(push({ pathname: '/settings/do_not_disturb' }))}>
          <i className="SettingsHome__icon SettingsHome__icon--do-not-disturb"/>
          <i className="SettingsHome__indicator fa fa-chevron-right" aria-hidden="true"/>
          <div className="SettingsHome__item-inner">
            <div className="SettingsHome__label">Do Not Disturb</div>
            <div className="SettingsHome__value">{doNotDisturbValue}</div>
          </div>
        </div>
        <div className="SettingsHome__item clickable" onClick={() => dispatch(push({ pathname: '/settings/notification' }))}>
          <i className="SettingsHome__icon SettingsHome__icon--notification"/>
          <i className="SettingsHome__indicator fa fa-chevron-right" aria-hidden="true"/>
          <div className="SettingsHome__item-inner">
            <div className="SettingsHome__label">Notification Mode</div>
            <div className="SettingsHome__value">{notificationModeValue}</div>
          </div>
        </div>
      </div>

      { !isEmbedded() && <OptionsSection dispatch={dispatch} auth={auth}/> }

      <UpdateAppModal />
    </div>
  )
}

export default SettingsHome
